import __request__ from "routing/request";
export function listNotifications(page = 1, per_page = 50, query) {
  return __request__("GET", "/events/notifications", null, { "page": page, "per_page": per_page, "query": query }, {
    "Accept": ["application/json"]
  });
}
export function create(JSONBody) {
  return __request__("POST", "/events/notifications", JSONBody, {}, {
    "Accept": ["application/json"]
  });
}
export function legacyTypes() {
  return __request__("GET", "/events/notifications/legacy/types", null, {}, {
    "Accept": ["application/json"]
  });
}
export function getPage(sort = "title", page = 1, per_page = 50, query, order = "asc") {
  return __request__("GET", "/events/notifications/paginated", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  });
}
export function test(JSONBody) {
  return __request__("POST", "/events/notifications/test", JSONBody, {}, {
    "Accept": ["application/json"]
  });
}
export function get(notificationId) {
  return __request__("GET", `/events/notifications/${notificationId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function update(notificationId, JSONBody) {
  return __request__("PUT", `/events/notifications/${notificationId}`, JSONBody, {}, {
    "Accept": ["application/json"]
  });
}
export function remove(notificationId) {
  return __request__("DELETE", `/events/notifications/${notificationId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function testBynotificationId(notificationId) {
  return __request__("POST", `/events/notifications/${notificationId}/test`, null, {}, {
    "Accept": ["application/json"]
  });
}
